<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("TITLES.editPackage") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #724c80">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- Start:: Name Input -->
          <base-image-upload-input
            col="12"
            identifier="admin_image"
            :placeholder="$t('PLACEHOLDERS.packageImage')"
            @selectImage="selectImage"
            :preSelectedImage="data.image.path"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameAr')"
            v-model.trim="data.name_ar"
            required
          />
          <!-- <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameEn')"
            v-model.trim="data.name_en"
            required
          /> -->
          <!-- End:: Name Input -->
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descAr')"
            v-model.trim="data.desc_ar"
            required
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descEn')"
            v-model.trim="data.desc_en"
            required
          />
          <!-- End:: Name Input -->
          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.packageTime')"
            v-model.trim="data.packageTime"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.packagePrice')"
            v-model.number="data.packagePrice"
            required
          />
          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.candidatesNum')"
            v-model.trim="data.candidatesNum"
            required
          />
          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.applicantsLimit')"
            v-model.trim="data.applicantsLimit"
            required
          />
          <div class="input_wrapper switch_wrapper my-5">
            <v-switch
              color="green"
              :label="
                data.active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.active"
              hide-details
            ></v-switch>
          </div>
          <!-- End:: Deactivate Switch Input -->

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "EditPackage",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        image: {
          path: null,
          file: null,
        },
        name_ar: null,
        name_en: null,
        desc_ar: null,
        desc_en: null,
        packageTime: null,
        packagePrice: null,
        candidatesNum: null,
        perioud: null,
        applicantsLimit: null,
        active: true,
      },
      capacities: [],

      // End:: Data Collection To Send
    };
  },

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),
  },

  methods: {
    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },
    async getCapacities() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `capacities`,
        });
        this.capacities = res.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;
      this.submitForm();
    },

    async submitForm() {
      const REQUEST_DATA = new FormData();
      // Start:: Append Request Data

      if (this.data.name_ar) {
        REQUEST_DATA.append("name[ar]", this.data.name_ar);
      }
      if (this.data.name_en) {
        REQUEST_DATA.append("name[en]", this.data.name_en);
      }
      if (this.data.desc_ar) {
        REQUEST_DATA.append("description[ar]", this.data.desc_ar);
      }
      if (this.data.desc_en) {
        REQUEST_DATA.append("description[en]", this.data.desc_en);
      }
      if (this.data.packagePrice) {
        REQUEST_DATA.append("price", this.data.packagePrice);
      }
      if (this.data.packageTime) {
        REQUEST_DATA.append("duration", this.data.packageTime);
      }
      if (this.data.candidatesNum) {
        REQUEST_DATA.append("candidate_count", this.data.candidatesNum);
      }
      if (this.data.applicantsLimit) {
        REQUEST_DATA.append("max_applicants", this.data.applicantsLimit);
      }
      if (this.data.image.file) {
        REQUEST_DATA.append("image", this.data.image.file);
      }
      REQUEST_DATA.append("is_active", this.data.active ? 1 : 0);
      REQUEST_DATA.append("_method", "PUT");
      try {
        await this.$axios({
          method: "POST",
          url: `packages/${this.$route.params?.id}`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.editedSuccessfully"));
        this.$router.push({ path: "/packages/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },

    // start show data
    async showPackage() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `packages/${this.$route.params?.id}`,
        });
        this.data.image.path = res.data.data.Package.image;
        this.data.name_ar = res.data.data.Package.name_ar;
        this.data.name_en = res.data.data.Package.name_en;
        this.data.desc_ar = res.data.data.Package.description_ar;
        this.data.desc_en = res.data.data.Package.description_en;
        this.data.packageTime = res.data.data.Package.duration;
        this.data.packagePrice = res.data.data.Package.price;
        this.data.candidatesNum = res.data.data.Package.candidate_count;
        this.data.applicantsLimit = res.data.data.Package.max_applicants;
        this.data.active = res.data.data.Package.is_active;
      } catch (error) {
        this.loading = false;
        console.log(error?.response?.data?.message);
      }
    },
    // end show data
  },

  created() {
    this.showPackage();
    this.getCapacities();
  },
};
</script>
